import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import Grid from '@material-ui/core/Grid';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { Formik } from 'formik';
import { makeStyles } from '@material-ui/core/styles';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { getSuburbsByCp } from '../../utils/cities';
import ButtonBase from '../Buttons/ButtonBase';
import { createBillingLaywers } from '../../store/actions/billingAction';
import { validationBilling } from '../../utils/validations';
import { CFDI } from '../../utils/Facturas/CFDI';
import {
  TextField,
  MenuItem,
} from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  formHelperTextRoot: {
    margin: '8px 14px',
    marginBottom: 0,
  },
  inputError: {
    border: '1px solid #d74242',
    '&:hover': {
      border: '1px solid #d74242',
    },
  },
  TextField: {
    maxWidth: '448px',
  },
  inputLabelRoot: {
    transform: 'translate(14px, 16px) scale(1)',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    right: 22,
    bottom: 0,
  },
  inputLabelShrink: {
    transform: 'translate(14px, -6px) scale(0.75)',
    zIndex: 10,
    right: 'unset',
    backgroundColor: '#fff',
    height: 'fit-content',
  },
  TextField_small: {
    maxWidth: '46%',
  },
  ButtonBase: {
    padding: 0,
    margin: 0,
    width: (screenSm) => (screenSm ? 144 : 184),
    minWidth: 'initial',
    marginTop: (screenSm) => (screenSm ? 16 : 32),
  },
  linkStyle: {
    width: (screenSm) => (screenSm ? 144 : 184),
    margin: (screenSm) => (screenSm ? '0 16px 0 0' : '0 32px 0 0'),
    '&:$last-child': {
      margin: 0,
    },
  },
}));

const BillingEditionForm = (props) => {
  const { billing, handleCancel } = props;
  const classes = useStyles();
  const [flagLocation, setFlagLocation] = useState(false);
  const [location, setLocation] = useState({});
  const [neighborhoodData, setNeighborhoodData] = useState();
  const [laywerId, setLaywerId] = useState();
  const [flagNeighborhood, setFlagNeighborhood] = useState()

  const screenMd = useMediaQuery('(max-width: 960px)');
  const screenLg = useMediaQuery('(max-width: 1280px)');

  useEffect(() => {
    setLaywerId(props.laywerUid);
    if (billing && billing.billingForm === false) {
      handleZipCodeData();
    }
    billing && billing.neighborhood && setFlagNeighborhood(true)
  }, []);


  const handleZipCodeData = async () => {
    let location = await getSuburbsByCp(parseInt(billing.zipCode));
    setLocation(location);
  };

  const formBillingValues = {
    nameLawyerOrLawFirm: billing ? billing.nameLawyerOrLawFirm : '',
    rfc: billing ? billing.rfc : '',
    cfdi: billing ? billing.cfdi : [],
    invoiceEmail: billing ? billing.invoiceEmail : '',
    invoicePhoneNumber: billing ? billing.invoicePhoneNumber : '',
    country: billing ? billing.country : '',
    zipCode: billing ? billing.zipCode : '',
    states: billing ? billing.states : '',
    city: billing ? billing.city : '',
    municipality: billing ? billing.municipality : '',
    neighborhood: billing ? billing.neighborhood : '',
    street: billing ? billing.street : '',
    outdoorNumber: billing ? billing.outdoorNumber : '',
  };

  const handleSubmitBillingForm = async (values, {  setFieldError }) => {
    if(values.zipCode == '' || values.zipCode == undefined){
      values = { 
        ...values, 
        billingForm:true,
        country:"", 
        municipality: "", 
        neighborhood: "",
        outdoorNumber:"",
        street: "",
        city:"",
        states:"", 
        invoicePhoneNumber: values.invoicePhoneNumber == "" ? "" : values.invoicePhoneNumber
      }
    } else {
      values = { 
        ...values, 
        billingForm: true,
        country: "México",
        municipality: location.municipio,
        neighborhood: neighborhoodData === undefined ? billing.neighborhood : neighborhoodData,
        city: values.ciudad === null ? '' : location.ciudad,
        states: location.estado,
        invoicePhoneNumber: values.invoicePhoneNumber == "" ? "" : values.invoicePhoneNumber
      }
    }

    if (values.city === undefined) {
      values['city'] = ''
    }
    if (values.municipality === undefined) {
      values['municipality'] = ''
    }
    if (values.states === undefined) {
      values['states'] = ''
    }
    try {
      await props.createBillingLaywers(laywerId, values, setFieldError)
      // console.log('handleCancel()');
      handleCancel()
    } catch (error) {}
  };

  const handleGetStatesByZipCode = async (event, setFieldError, setErrors) => {

    let location = await getSuburbsByCp(event.target.value);
    console.log('location2', location)
    setFlagNeighborhood(false)
    if (!location) {
      setFieldError('zipCode', 'error')
      setErrors({ zipCode: 'Este código postal no es válido' })
      setFlagLocation(false);
    } else {
      setLocation(location);
      setFlagLocation(true);
    }
  };

  const selectNeighborhood = (params) => {
    setNeighborhoodData(params);
  };

  const handleRenderForm = (props) => {
    const {
      handleChange,
      handleSubmit,
      values,
      touched,
      errors,
      handleBlur,
      isValid,
      setFieldError,
      setErrors
    } = props;

    console.log('values', values);
    console.log('errors', errors);

    return (
      <form style={{ maxWidth: 840 }}>
        <Grid container spacing={screenMd ? 0 : 3} direction="column">
          <Grid container spacing={screenMd ? 0 : 3}>
            <Grid item xs={12} md={6}>
              <TextField
                label="Nombre del abogado o despacho*"
                name="nameLawyerOrLawFirm"
                type="text"
                variant="outlined"
                onBlur={handleBlur}
                value={values.nameLawyerOrLawFirm}
                onChange={handleChange}
                helperText={
                  touched.nameLawyerOrLawFirm && errors.nameLawyerOrLawFirm
                    ? errors.nameLawyerOrLawFirm
                    : ''
                }
                error={
                  touched.nameLawyerOrLawFirm && errors.nameLawyerOrLawFirm
                    ? true
                    : false
                }
                fullWidth
                classes={{ root: classes.TextField }}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                label="RFC*"
                name="rfc"
                type="text"
                variant="outlined"
                value={values.rfc}
                onInput={(e) => {
                  e.target.value = e.target.value.toUpperCase();
                }}
                inputProps={{ maxLength: 14 }}
                onBlur={handleBlur}
                onChange={handleChange}
                helperText={touched.rfc && errors.rfc ? errors.rfc : ''}
                error={touched.rfc && errors.rfc ? true : false}
                fullWidth
                classes={{ root: classes.TextField }}
              />
            </Grid>
          </Grid>

          <Grid container spacing={screenMd ? 0 : 3}>
            <Grid item xs={12} md={6}>
              <TextField
                id="cfdi"
                name="cfdi"
                select
                fullWidth
                label="Uso de CFDI*"
                variant="outlined"
                classes={{ root: classes.TextField }}
                value={values.cfdi}
                onChange={handleChange}
                helperText={
                  touched.cfdi && errors.cfdi ? errors.cfdi : ''
                }
                error={touched.cfdi && errors.cfdi ? true : false}
              >
                {CFDI.map((option) => (
                  <MenuItem key={option.code} value={option}>
                    {option.description}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                label={
                  screenMd
                    ? 'Correo electrónico (recibir la factura)*'
                    : 'Correo electrónico (donde deseas recibir la factura)*'
                }
                name="invoiceEmail"
                type="text"
                variant="outlined"
                value={values.invoiceEmail}
                onBlur={handleBlur}
                onChange={handleChange}
                helperText={
                  touched.invoiceEmail && errors.invoiceEmail
                    ? errors.invoiceEmail
                    : ''
                }
                error={
                  touched.invoiceEmail && errors.invoiceEmail ? true : false
                }
                fullWidth
                InputLabelProps={{
                  classes: {
                    root: classes.inputLabelRoot,
                    shrink: classes.inputLabelShrink,
                  },
                }}
                classes={{ root: classes.TextField }}
              />
            </Grid>
          </Grid>

          <Grid container spacing={screenMd ? 0 : 3}>
            <Grid item xs={12} md={6}>
              <TextField
                label="Número telefónico"
                name="invoicePhoneNumber"
                type="text"
                variant="outlined"
                value={values.invoicePhoneNumber}
                onBlur={handleBlur}
                onInput={(e) => {
                  e.target.value = e.target.value.replace(/[^0-9]/g, '');
                }}
                inputProps={{ minLength: 8, maxLength: 10 }}
                onChange={handleChange}
                helperText={
                  touched.invoicePhoneNumber && errors.invoicePhoneNumber
                    ? errors.invoicePhoneNumber
                    : ''
                }
                error={
                  touched.invoicePhoneNumber && errors.invoicePhoneNumber
                    ? true
                    : false
                }
                fullWidth
                classes={{ root: classes.TextField }}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                label="País"
                name="country"
                type="text"
                variant="outlined"
                onBlur={handleBlur}
                onChange={handleChange}
                value={'México'}
                fullWidth
                classes={{ root: classes.TextField }}
              />
            </Grid>
          </Grid>

          <Grid container spacing={screenMd ? 0 : 3}>
            <Grid item xs={12} md={6}>
              <TextField
                label="Código postal"
                name="zipCode"
                type="text"
                variant="outlined"
                value={values.zipCode}
                inputProps={{ maxLength: 5 }}
                onBlur={(event) =>
                  handleGetStatesByZipCode(event, setFieldError, setErrors)
                }
                onChange={(event)=> {
                  handleChange(event)
                  console.log(event.target.value)
                }}
                helperText={
                  touched.zipCode && errors.zipCode ? errors.zipCode : ''
                }
                error={touched.zipCode && errors.zipCode ? true : false}
                fullWidth
                classes={{ root: classes.TextField }}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                label={!flagLocation ? 'Estado' : 'Estado'}
                name="states"
                type="text"
                variant="outlined"
                value={location && location.estado ? location.estado : billing && billing.states}
                onBlur={handleBlur}
                onChange={handleChange}
                fullWidth
                classes={{ root: classes.TextField }}
              />
            </Grid>
          </Grid>

          <Grid container spacing={screenMd ? 0 : 3}>
            <Grid item xs={12} md={6}>
              <TextField
                label={!flagLocation ? 'Ciudad' : 'Ciudad'}
                name="city"
                type="text"
                variant="outlined"
                value={location && location.ciudad ? location.ciudad : billing && billing.city}
                onBlur={handleBlur}
                onChange={handleChange}
                fullWidth
                classes={{ root: classes.TextField }}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              { !flagNeighborhood ? <Autocomplete
                name="neighborhood"
                options={location.colonias}
                getOptionLabel={(option) => option}
                onChange={(event, newValue) => {
                  selectNeighborhood(newValue);
                }}
                disabled={!flagLocation}
                fullWidth
                renderInput={(params) => (
                  <TextField
                    {...params}
                    value={
                      neighborhoodData &&
                      billing.neighborhood &&
                      neighborhoodData === undefined
                        ? billing.neighborhood
                        : ''
                    }
                    label="Colonia"
                    type="text"
                    variant="outlined"
                    fullWidth
                    classes={{ root: classes.TextField }}
                  />
                )}
              /> : 
                <TextField
                    label="Colonia"
                    name="neighborhood"
                    type="text"
                    variant="outlined"
                    value={billing.neighborhood}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    helperText={
                      touched.street && errors.street ? errors.street : ''
                    }
                    error={touched.street && errors.street ? true : false}
                    fullWidth
                    classes={{ root: classes.TextField }}
                  />
              }
            </Grid>
          </Grid>

          <Grid container spacing={screenMd ? 0 : 3}>
            <Grid item xs={12} md={6}>
              <Grid container spacing={screenLg ? 0 : 3}>
                <Grid item xs={12} lg={6}>
                  <TextField
                    label="Calle"
                    name="street"
                    type="text"
                    variant="outlined"
                    value={values.street}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    helperText={
                      touched.street && errors.street ? errors.street : ''
                    }
                    error={touched.street && errors.street ? true : false}
                    fullWidth
                    classes={{ root: classes.TextField }}
                  />
                </Grid>
                <Grid item xs={12} lg={6}>
                  <TextField
                    label="No."
                    name="outdoorNumber"
                    type="text"
                    variant="outlined"
                    value={values.outdoorNumber}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    helperText={
                      touched.outdoorNumber && errors.outdoorNumber
                        ? errors.outdoorNumber
                        : ''
                    }
                    error={
                      touched.outdoorNumber && errors.outdoorNumber ? true : false
                    }
                    fullWidth
                    classes={{ root: classes.TextField }}
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>

        </Grid>

        <div style={{ display: 'flex' }}>
          <ButtonBase
            onClick={handleCancel}
            variant="primarySolidOutlined"
            linkStyle={classes.linkStyle}
            className={classes.ButtonBase}
          >
            Cancelar
          </ButtonBase>
          <ButtonBase
            type="submit"
            onClick={handleSubmit}
            className={classes.ButtonBase}
            variant="primary"
            disabled={!isValid}
          >
            Guardar
          </ButtonBase>
        </div>
      </form>
    );
  };
  return (
    <Formik
      initialValues={formBillingValues}
      validationSchema={validationBilling}
      onSubmit={handleSubmitBillingForm}
      render={handleRenderForm}
    />
  );
};

const mapDispatchToProps = (dispatch) => ({
  createBillingLaywers: (laywerUid, data,setFieldError) => dispatch(createBillingLaywers(laywerUid, data,setFieldError)),
});

const mapStateToProps = (state) => ({
  laywerUid: state.authClient.uid,
  modalPayments: state.ModalReducer.openModalPayments,
  role: state.authClient.role,
  billing: state.billingReducer.billingData,
});

export default connect(mapStateToProps, mapDispatchToProps)(BillingEditionForm);
